/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



/**
 * Google Optimize
 */

// Fallback
window.dataLayer = window.dataLayer || []

document.addEventListener('product:added', function(event) {
	dataLayer.push({
		event: 'Product Added'
	})
})



/**
 * Cart form validity
 * JS Fix because of weird/complex structured markup
 */

var formMobile = document.querySelector('[data-form-top]')
var formValidator = document.querySelector('[data-form-validator]')

if ( formMobile && formValidator ) {
  formMobile.addEventListener('submit', function(e) {
      if ( !formValidator.checkValidity() ) {
        e.preventDefault()
        formValidator.reportValidity()
      }
  })
}



/**
 * Collection sub categories dropdown
 */

var subcategories = document.querySelector('.sub-category')
if ( subcategories ) {
  var trigger = subcategories.querySelector('.sub-category-title')
  var contents = subcategories.querySelector('.sub-category-grid')

  trigger.addEventListener('click', function(event) {
    event.preventDefault()

    subcategories.classList.toggle('is-open')
    contents.style.height = subcategories.classList.contains('is-open') ? contents.scrollHeight + 'px' : null;
  })
}





var getCartItem = async function() {
  const response = await fetch("/cart.js")
    .then(resp => resp.json())
    .then(resp => resp);
  
    if (!response.items.length > 0) {
      return;
    }
    const item_id = response.items[0].product_id;
    miniCartRecs(item_id);
}

var miniCartRecs = function(item_id) {
  const limit = 4;
  fetch(`/recommendations/products.json?product_id=${item_id}&limit=${limit}`)
    .then(resp => resp.json())
    .then(resp => {
      var recs = resp.products;
      if (recs.length > 0) {
        const recsHeader = document.getElementById('miniCartHeader');
        const recsContainer = document.getElementById('miniCartRecs');
        const recsHTML = recs.map(rec => {
          return `
            <a href="${rec.url}" class="link">
              <img src="${rec.featured_image}" alt=""/>
              <p>${rec.title}</p>
            </a>
          `
        }).join("");
        const also_like = window.languages.also_like;
        recsHeader.innerHTML = '';
        recsHeader.insertAdjacentHTML( 'afterbegin', `<h3 class="section__title heading h3">${also_like}</h3>`);
        recsContainer.innerHTML = recsHTML;
      }
    });
};

document.addEventListener('theme:loading:end', function(event) {
  getCartItem()
});

getCartItem();

// Bulk discounts slider
var bulkSliderElement = document.querySelector('.bulk-discounts__carousel');

if (bulkSliderElement) {
  var bulkSlider = new Flickity(bulkSliderElement, {
    prevNextButtons: true,
    pageDots: false,
    cellAlign: 'left',
    adaptiveHeight: false,
    contain: true,
    groupCells: true,
    groupCells: '80%'
  });
}

document.addEventListener('variant:changed', function(event) {
  
  if (window.theme.enableBackInStock) {
    var variant = event.detail.variant;
    var bisTrigger = document.querySelector("#BIS_trigger");
    var addToCart = document.querySelector("#addToCart");
  
    if (variant.available) {
      // Hide 'back-in-stock' button if variant is out of stock          
      bisTrigger.style.display = "none"; // hide the button
      addToCart.style.display = "block";
    } else {
      // Show 'back-in-stock' button if variant is out of stock, hide 'add-to-cart'
      bisTrigger.style.display = "block"; // show the button
      bisTrigger.setAttribute("data-variant-id", variant.id); // set the default variant
      addToCart.style.display = "none";
    }
  }

});

document.addEventListener('product:added', function(event) {
  console.log(event)
  var variant = event.detail.variant; // Get the variant that was added
  var quantity = event.detail.quantity; // Get the quantity that was added

  if (variant) {
    var buyWith = document.getElementById('buy-with');
    if (buyWith) {
      var checks = buyWith.querySelectorAll('input[type="checkbox"]:checked');
      var items = Array.from(checks).map(item => {
        return {
          id: parseInt(item.value),
          quantity: 1
        };
      });
      console.log(items);
      if (items.length) {
        addBuyWith(items);
      }
    } else {
      return;
    }
  } else {
    return;
  }
});

var addBuyWith = function(items) {
  fetch(window.theme.localeRootUrl + '/cart/add.js', {
    credentials: 'same-origin',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
    },
    body: JSON.stringify({items})
  }).then(function (response) {
    if (response.ok) {
      console.log("item added");
      document.documentElement.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          quantity: 1,
          ignore: true
        }
      }));
    } else {
      console.error("problem: ", response);
    }
  });
};


// Update alt variants
var altVariants = document.getElementById("alt-variants");

if (altVariants) {
  var colourTitleEl = altVariants.querySelector(".alt-variants__colour-title");
  var originalColourTitle = colourTitleEl.dataset.title;
  
  function updateColour() {
    console.log(this, "update");
    var colourTitle = this.dataset.title;
    colourTitleEl.textContent = colourTitle;
  };
  
  function resetColour() {
    colourTitleEl.textContent = originalColourTitle;
  };
  
  altVariants.querySelectorAll(".alt-variants__variant").forEach(element => {
    element.addEventListener("mouseenter", updateColour);
    element.addEventListener("focus", updateColour);
    
    element.addEventListener("mouseleave", resetColour);
    element.addEventListener("blur", resetColour);
  });
}